import React, { useState, useMemo } from 'react'
import { Box, Text, IcoMoon, PlusIcon } from '@usap/uicomponents'
import ImageUpload from './ImageUpload'
import { Heading5 } from '../../../../common/heading'
import getLastThreshold from './utils/getLastThreshold'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import ImageGalleryItemWMO from './ImageGalleryItemWMO'

const ImageGalleryItem = props => {
  const {
    widgets,
    onChange,
    formFile = {},
    isDesktop,
    removeImage,
    errorSteps,
    selectedPart,
  } = props

  const requiredData = widgets.required
    ? ''
    : ' <em style="font-size: 12px;font-weight: normal">(Optional)</em>'

  const headerText = `${widgets.title}${requiredData}`
  const [threshold, setThreshold] = useState(getLastThreshold(widgets?.props, formFile))

  const isWmoEnabled = useWmoEnabled()

  const addMore = useMemo(
    () => {
      const checkCurrentUploadedFile = widgets.props?.filter(x => formFile[x.id])
      const disabled = Object.keys(checkCurrentUploadedFile).length < threshold

      if (threshold >= widgets.props.length) return null

      return (
        <Box
          width={isDesktop ? '100px' : '80px'}
          height={isDesktop ? '120px' : '100px'}
          margin={{ bottom: '24px' }}
          style={{
            marginRight: isDesktop ? '15px' : '4px',
            fontSize: '14px',
            textAlign: 'center',
            opacity: disabled ? '0.5' : '1',
          }}
        >
          <Box
            width={isDesktop ? '100px' : '80px'}
            height={isDesktop ? '120px' : '80px'}
            style={{
              border: '1px solid #ccc',
              cursor: 'pointer',
              paddingTop: isDesktop ? '30px' : '22px',
              alignSelf: 'center',
            }}
            onClick={
              () => setThreshold(prev => (!disabled
                && prev < widgets.props.length ? prev + 1 : prev))
            }
          >
            <IcoMoon
              icon={PlusIcon}
              color="#05629b"
              size={isDesktop ? '42px' : '32px'}
              style={{
                alignSelf: 'center',
                marginLeft: '8px',
              }}
            />
          </Box>
          <Text size="small" margin={{ top: '8px' }} style={{ color: '#05629b' }}>
            Add More
          </Text>
        </Box>
      )
    }, [formFile, widgets, threshold, isDesktop],
  )

  if(isWmoEnabled) {
    return (
      <ImageGalleryItemWMO 
        {...props}
        threshold={threshold}
        setThreshold={setThreshold}
      />
    )
  }

  return (
    <Box>
      <Heading5
        width="large"
        key={widgets.id}
        title={headerText}
        size={isDesktop ? 'medium' : 'small'}
        color="#000"
        style={{ fontSize: '14px', fontWeight: 700, maxWidth: '100%' }}
        margin={{ bottom: '8px' }}
      />

      {widgets.subtitle && (
        <Box alignContent="start" alignSelf="start">
          <Text size="small">{widgets.subtitle}</Text>
        </Box>
      )}

      <Text id={`error-${widgets.id}`} style={{ color: '#f90000', fontSize: '12px' }}>
        {errorSteps[widgets.id]}
      </Text>

      <Box
        direction="row"
        alignContent="start"
        alignSelf="start"
        margin={{ top: '16px' }}
        style={{
          flexFlow: 'row wrap',
        }}
      >
        {widgets.props.map((attr, index) => index + 1 <= threshold
            && (
            <ImageUpload
              isDesktop={isDesktop}
              key={`${widgets.id}-${attr.id}`}
              attr={attr}
              widgets={widgets}
              onChange={onChange}
              removeImage={removeImage}
              formFile={formFile}
              selectedPart={selectedPart}
              required={widgets.required}
            />
            ))}
        {addMore}
      </Box>
    </Box>
  )
}

export default ImageGalleryItem
